import { withCurrentParams } from 'actions/utils';
import { BROADCAST_UPDATE_STREAM_ENDPOINT } from 'actions/Types';
import { ENDPOINT_UPDATE } from 'store/eventConstants';

/**
 * Update Endpoint
 *
 * @param {*} payload Updated endpoint payload
 * @param {*} currentEndpoint endpoint to update
 */
export default (payload, currentEndpoint) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const endpointId = currentEndpoint._id;
      const action = {
        type: BROADCAST_UPDATE_STREAM_ENDPOINT,
        request: async apiClient => {
          const resp = await apiClient.broadcast.updateStreamEndpoint(
            teamId,
            eventId,
            broadcastId,
            endpointId,
            payload
          );
          // notify other directors
          socket.emit(ENDPOINT_UPDATE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return resp;
        }
      };
      dispatch(action);
    }
  );
};
